import {TableSortLabel} from '@material-ui/core';
import t from 'prop-types';
import React from 'react';
import AmpTableCell from './TableCell';

const Th = ({toggleSort, children, className, style, sortable = true}) => {
  const sortActive = className.includes('-sort');
  const sortingDir = className.includes('-sort-desc') ? 'desc' : 'asc';
  return (
    <AmpTableCell
      className={className}
      style={{
        cursor: sortable && 'pointer',
        textAlign: 'left',
        position: 'relative',
        textTransform: 'uppercase',
        fontSize: '10px',
        color: 'gray',
        ...style,
      }}
      onClick={e => toggleSort && toggleSort(e)}
    >
      {children}
      {sortable && (
        <TableSortLabel
          style={{position: 'absolute', padding: 'inherit', top: 0, right: 0}}
          active={sortActive}
          direction={sortingDir}
        />
      )}
    </AmpTableCell>
  );
};

Th.propTypes = {
  toggleSort: t.func,
  children: t.node,
  className: t.string,
  style: t.object,
  sortable: t.bool,
};

export default Th;
